import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ConsoleTabService } from './console-tab.service';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TitleService {

  private platformName = 'Ocelus';

  constructor(private titleService: Title) {
  }
 
  setTitle(title:string){
    const completeTitle = `${title} | ${this.platformName}`;
    this.titleService.setTitle(completeTitle );
  }

}
